export default {
  selfServe: {
    back: "Back",
    buy: "Buy",
    promo: "PROMO",
    tab: {
      credit: "Credits Packages",
      brickz: "Brickz",
    },
    brickz: {
      alert: {
        title: "Please note:",
        expired:
          "Your Brickz access has expired. Purchase a Brickz add-on to gain access to the latest transacted properties data now.",
        expirySoon: "Your Brickz current access will expire on",
      },
    },
    tnc: {
      title: "T&Cs applies",
      remarks: "*Total price displayed is inclusive of {percent}% SST",
    },
  },
};
